import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=e0509b26&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=e0509b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0509b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0509b26')) {
      api.createRecord('e0509b26', component.options)
    } else {
      api.reload('e0509b26', component.options)
    }
    module.hot.accept("./TaskDetails.vue?vue&type=template&id=e0509b26&scoped=true&", function () {
      api.rerender('e0509b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/taskmanager/TaskDetails.vue"
export default component.exports